export class WeeklyAllocationGoal
{
    id?: number;
    siteId: string;
    subinventoryId: number;
    nominalYear: number;
    nominalMonth: number;
    weekOfMonth: number;
    metricId: number;
    activityValue: string;

    // used in page to know from whence an inherited goal came
    parent?: WeeklyAllocationGoal;
}
